module.exports = __webpack_public_path__ + "static/media/money1.0bb9454b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/money1.png
// module id = 663
// module chunks = 0 1